import React, { useReducer, useContext } from 'react';
import firebase from 'firebase';

import { firestoreInitialize } from 'config/firebase/client';

import PetPointsContext from './PetPointsContext';
import PetPointsReducer from './PetPointsReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const PetPointsState = (props) => {
    const initialState = {
        getPetPoints: {
            petPoints: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getPetPointsById: {
            petPoint: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getPetPointsByAlly: {
            petPoint: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getPetPointsEvents: {
            petPointsEvents: [],
            firstPetPointsEvent: null,
            lastPetPointsEvent: null,
            nextPetPointsEvents: null,
            petPointsEventsFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getPetPointsEventsMigrate: {
            petPointsEvents: [],
            petPointsEventsMigrate: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        migratePetPointEvents: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getPetPointsEventsApplication: {
            petPointsEventsApplication: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        createPetPointEvents: {
            petPointEvent: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        updatePetPointEvents: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        deletePetPointEvent: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
    }

    const [state, dispatch] = useReducer(PetPointsReducer, initialState);

    const { authenticatedState } = useContext(AuthenticationContext);

    const getPetPoints = (country) => {
        dispatch({ type: 'GET_PETPOINTS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalPetPoints(country);
        } else {
            getPetPointsPerCountry(authenticatedState.user.pais);
        }
    }

    const getGlobalPetPoints = (country) => {
        let db = firestoreInitialize();

        if (country) {
            let petPoints = db.collectionGroup('Petpoints')
                .where('pais', '==', country)
        
            petPoints.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_PETPOINTS', payload: documentSnapshots.docs.map(doc => doc.data()) });
            })
        .catch(error => dispatch({ type: 'GET_PETPOINTS_ERROR', payload: { code: 'petpoints/error', message: error } }))   
        } else {
            let petPoints = db.collectionGroup('Petpoints')
            
            petPoints.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_PETPOINTS', payload: documentSnapshots.docs.map(doc => doc.data()) });
            })
            .catch(error => dispatch({ type: 'GET_PETPOINTS_ERROR', payload: { code: 'petpoints/error', message: error } }))   
        }
    }

    const getPetPointsPerCountry = (country) => {
        let db = firestoreInitialize();

        let petPoints = db.collectionGroup('Petpoints')
            .where('pais', '==', country)

        petPoints.get().then((documentSnapshots) => {
            dispatch({ type: 'GET_PETPOINTS', payload: documentSnapshots.docs.map(doc => doc.data()) });
        })
        .catch(error => dispatch({ type: 'GET_PETPOINTS_ERROR', payload: { code: 'petpoints/error', message: error } }))   
    }

    const getPetPointsById = (type, id) => {
        if (type === 0) {
            dispatch({ type: 'GET_PETPOINTS_BY_ID_LOADING' });

            let db = firestoreInitialize();

            let docRef = db.collectionGroup("Petpoints").where('aliadoId', '==', id);

            docRef.get().then((doc) => {
                if (doc.exists) {
                    dispatch({ type: 'GET_PETPOINTS_BY_ID', payload: doc.data() })
                } else {
                    dispatch({ type: 'GET_PETPOINTS_BY_ID', payload: null })
                }
            }).catch((error) => {
                dispatch({ type: 'GET_PETPOINTS_BY_ID_ERROR', payload: { code: 'petpoints/error', message: error }})
            });
        } else {
            dispatch({ type: 'GET_PETPOINTS_BY_ID_LOADING' });

            let db = firestoreInitialize();

            let docRef = db.collection("Petpoints")
                .where('uid', '==', id)

            docRef.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_PETPOINTS_BY_ID', payload: documentSnapshots.docs.map(doc => doc.data()) })
            }).catch((error) => {
                dispatch({ type: 'GET_PETPOINTS_BY_ID_ERROR', payload: { code: 'customers/customers-error', message: error }})
            });
        }
    };

    const getPetPointsByAll = (id) => {
        let db = firestoreInitialize();

        db.collectionGroup("Petpoints")
            .where('aliadoId', '==', id)
            .get()
            .then((querySnapshot) => {
                const dataAlly = querySnapshot.docs.map(doc => doc.data());

                if (dataAlly.length > 0) {
                    dispatch({ type: 'GET_PETPOINTS_BY_ID', payload: dataAlly[0] })
                } else {
                    db.collectionGroup("Petpoints")
                    .where('uid', '==', id)
                    .get()
                    .then((querySnapshot) => {
                        const dataCustomer = querySnapshot.docs.map(doc => doc.data());
        
                        dispatch({ type: 'GET_PETPOINTS_BY_ID', payload: dataCustomer[0] })
                    })
                    .catch((error) => dispatch({ type: 'GET_PETPOINTS_BY_ID_ERROR', payload: { code: 'pet-points/error', message: error } }))
                }
            })
            .catch((error) => dispatch({ type: 'GET_PETPOINTS_BY_ID_ERROR', payload: { code: 'pet-points/error', message: error } }))
    };

    const getPetPointsByAlly = (ally) => {
        dispatch({ type: 'GET_PETPOINTS_BY_ID_LOADING' })

        let db = firestoreInitialize();

        db.collectionGroup("Petpoints")
            .where('aliadoId', '==', ally)
            .get()
            .then((querySnapshot) => {
                const dataAlly = querySnapshot.docs.map(doc => doc.data());
                dispatch({ type: 'GET_PETPOINTS_BY_ID', payload: dataAlly[0] })
            })
            .catch((error) => dispatch({ type: 'GET_PETPOINTS_BY_ID_ERROR', payload: { code: 'pet-points/error', message: error } }))
    };

    const getPetPointsByCustomer = (customer) => {
        dispatch({ type: 'GET_PETPOINTS_BY_ID_LOADING' })

        let db = firestoreInitialize();

        db.collectionGroup("Petpoints")
            .where('uid', '==', customer)
            .get()
            .then((querySnapshot) => {
                const dataCustomer = querySnapshot.docs.map(doc => doc.data());
                dispatch({ type: 'GET_PETPOINTS_BY_ID', payload: dataCustomer[0] })
            })
            .catch((error) => dispatch({ type: 'GET_PETPOINTS_BY_ID_ERROR', payload: { code: 'pet-points/error', message: error } }))
    };

    const getPetPointsByAlliesArray = (allies) => {
        let db = firestoreInitialize();
        
        let petPoints = db.collectionGroup('Petpoints')
            .where('aliadoId', 'in', allies)
        
        petPoints.get().then((documentSnapshots) => {
            dispatch({ type: 'GET_PETPOINTS', payload: documentSnapshots.docs.map(doc => doc.data()) });
        })
        .catch(error => dispatch({ type: 'GET_PETPOINTS_ERROR', payload: { code: 'petpoints/error', message: error } }))   
    }

    const getPetPointsByCustomersArray = (customers) => {
        let db = firestoreInitialize();
        
        let petPoints = db.collectionGroup('Petpoints')
            .where('uid', 'in', customers)
        
        petPoints.get().then((documentSnapshots) => {
            dispatch({ type: 'GET_PETPOINTS', payload: documentSnapshots.docs.map(doc => doc.data()) });
        })
        .catch(error => dispatch({ type: 'GET_PETPOINTS_ERROR', payload: { code: 'petpoints/error', message: error } }))   
    }

    const getPetPointsEvents = (nextPage, prevPage, country, notPagination) => {
        dispatch({ type: 'GET_PET_POINTS_EVENTS_LOADING' });

        if (country) {
            getPetPointsEventsPerCountry(nextPage, prevPage, notPagination, country);
        } else if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalPetPointsEvents(nextPage, prevPage, notPagination);
        } else {
            getPetPointsEventsPerCountry(nextPage, prevPage, notPagination, authenticatedState.user.pais);
        }
    };

    const getGlobalPetPointsEvents = (nextPage, prevPage, notPagination) => {
        dispatch({ type: 'GET_PET_POINTS_EVENTS_LOADING' });

        let db = firestoreInitialize();

        if (notPagination) {
            let first = db.collection("Eventos");

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
            })
            .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_ERROR', payload: { code: 'pet-points-events/error', message: error } }))   
        } else if (nextPage) {
            let first = db.collection("Eventos")
                .orderBy('eventoId')
                .startAfter(nextPage)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Eventos")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_ERROR', payload: { code: 'pet-points-events/error', message: error } }))   
        } else if (prevPage) {
            let first = db.collection("Eventos")
                .orderBy('eventoId')
                .endBefore(prevPage)
                .limitToLast(10);

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Eventos")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_ERROR', payload: { code: 'pet-points-events/error', message: error } }))   
        } else {
            let first = db.collection("Eventos")
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Eventos")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_ERROR', payload: { code: 'pet-points-events/error', message: error } }))   
        }
    }

    const getPetPointsEventsPerCountry = (nextPage, prevPage, notPagination, country) => {
        dispatch({ type: 'GET_PET_POINTS_EVENTS_LOADING' });

        let db = firestoreInitialize();

        if (notPagination) {
            let first = db.collection("Ciudades").doc(country).collection("AsignacionPuntos")

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
            })
            .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_ERROR', payload: { code: 'pet-points-events/error', message: error } }))   
        } else if (nextPage) {
            db.collection("Ciudades").doc(country).collection("AsignacionPuntos")
                .where('eventoId', '==', nextPage)
                .limit(1)
                .get().then((querySnapshot) => {
                    let first = db.collection("Ciudades").doc(country).collection("AsignacionPuntos")
                    .startAfter(querySnapshot.docs[0])
                    .limit(10)

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Ciudades").doc(country).collection("AsignacionPuntos")
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_ERROR', payload: { code: 'pet-points-events/error', message: error } }))   
        } else if (prevPage) {
            db.collection("Ciudades").doc(country).collection("AsignacionPuntos")
                .where('eventoId', '==', prevPage)
                .limit(1)
                .get().then((querySnapshot) => {

                    let first = db.collection("Ciudades").doc(country).collection("AsignacionPuntos")
                    .endBefore(querySnapshot.docs[0])

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=data.length-10];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Ciudades").doc(country).collection("AsignacionPuntos")
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                const length = data.length - 10;

                                data.splice(0, length);

                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_ERROR', payload: { code: 'pet-points-events/error', message: error } }))   
        } else {
            let first = db.collection("Ciudades").doc(country).collection("AsignacionPuntos")
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Ciudades").doc(country).collection("AsignacionPuntos")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PET_POINTS_EVENTS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_ERROR', payload: { code: 'pet-points-events/error', message: error } }))   
        }
    }

    const getPetPointsEventsMigrate = (country, countryToMigrate) => {
        dispatch({ type: 'GET_PET_POINTS_EVENTS_MIGRATE_LOADING' });

        let db = firestoreInitialize();

        let first = db.collection("Ciudades").doc(countryToMigrate).collection("AsignacionPuntos")

        first.get().then((documentSnapshots) => {
            const dataToMigrate = documentSnapshots.docs.map(doc => doc.data());

            first = db.collection("Ciudades").doc(country).collection("AsignacionPuntos")

            first.get().then((documentSnapshots) => {
                const data = documentSnapshots.docs.map(doc => doc.data());

                dispatch({ type: 'GET_PET_POINTS_EVENTS_MIGRATE', payload: { data: data, dataMigrate: dataToMigrate }});
            })
            .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_MIGRATE_ERROR', payload: { code: 'pet-points-events-migrate/error', message: error } }))   
        })
        .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_MIGRATE_ERROR', payload: { code: 'pet-points-events-migrate/error', message: error } }))   
    }

    const getPetPointsEventsApplication = () => {
        dispatch({ type: 'GET_PET_POINTS_EVENTS_APPLICATION_LOADING' });

        let db = firestoreInitialize();

        let first = db.collection("EventosAplicacion");

        first.get().then((documentSnapshots) => {
            dispatch({ type: 'GET_PET_POINTS_EVENTS_APPLICATION', payload: { data: documentSnapshots.docs.map(doc => doc.data()) }});
        })
        .catch(error => dispatch({ type: 'GET_PET_POINTS_EVENTS_APPLICATION_ERROR', payload: { code: 'pet-points-events-application/error', message: error } }))   
    };

    const migratePetPointEvents = (dataList, migrateDataList, countryId) => {
        dispatch({ type: 'MIGRATE_PET_POINT_EVENT_LOADING' });

        let db = firestoreInitialize();

        if (dataList.length > 0) {
            dataList.forEach(data => {
                db.collection("Ciudades").doc(countryId).collection("AsignacionPuntos").doc(data.eventoId).delete().then((doc) => {
                    
                })
                .catch((error) => dispatch({ type: 'MIGRATE_PET_POINT_EVENT_ERROR', payload: { code: 'create-pet-point-events/error', message: error } }))
            });
        }

        migrateDataList.forEach(data => {
            db.collection("Ciudades").doc(countryId).collection("AsignacionPuntos").add({
                eventoId: "",
                paisId: countryId,
                tipoTransaccion: data.tipoTransaccion,
                tipoMonto: data.tipoMonto,
                dueño: data.dueño,
                aliado: data.aliado,
                permanente: data.permanente,
                desde: data.desde,
                hasta: data.hasta,
                createdOn: firebase.firestore.FieldValue.serverTimestamp()
            }).then((doc) => {
                db.collection("Ciudades").doc(countryId).collection("AsignacionPuntos").doc(doc.id).update({
                    eventoId: doc.id
                })
            })
            .catch((error) => dispatch({ type: 'MIGRATE_PET_POINT_EVENT_ERROR', payload: { code: 'create-pet-point-events/error', message: error } }))
        });

        dispatch({ type: 'MIGRATE_PET_POINT_EVENT', payload: { data: migrateDataList } });
    };

    const migratePetPointEventResetState = () => {
        dispatch({ type: 'MIGRATE_PET_POINT_EVENT_RESET_STATE' });
    };

    const createPetPointEvents = (data, countryId) => {
        dispatch({ type: 'CREATE_PET_POINT_EVENT_LOADING' });

        let db = firestoreInitialize();

        db.collection("Ciudades").doc(countryId).collection("AsignacionPuntos").add({
            eventoId: "",
            paisId: countryId,
            tipoTransaccion: data.tipoTransaccion,
            tipoValor: data.tipoValor,
            dueño: data.dueño,
            aliado: data.aliado,
            permanente: data.permanente,
            desde: data.desde,
            hasta: data.hasta,
            createdOn: firebase.firestore.FieldValue.serverTimestamp()
        }).then((doc) => {
            db.collection("Ciudades").doc(countryId).collection("AsignacionPuntos").doc(doc.id).update({
                eventoId: doc.id
            }).then(() => dispatch({ type: 'CREATE_PET_POINT_EVENT', payload: doc.id }));
        })
        .catch((error) => dispatch({ type: 'CREATE_PET_POINT_EVENT_ERROR', payload: { code: 'create-pet-point-events/error', message: error } }))
    };

    const resetCreatePetPointEventState = () => {
        dispatch({ type: 'CREATE_PET_POINT_EVENT_RESET_STATE' });
    };

    const updatePetPointEvent = (id, countryId, data) => {
        dispatch({ type: 'UPDATE_PET_POINT_EVENT_LOADING' });

        let db = firestoreInitialize();

        db.collection("Ciudades").doc(countryId).collection("AsignacionPuntos").doc(id).update({
            tipoTransaccion: data.tipoTransaccion,
            tipoValor: data.tipoValor,
            dueño: data.dueño,
            aliado: data.aliado,
            permanente: data.permanente,
            desde: data.desde,
            hasta: data.hasta,
        }).then((doc) => {
            dispatch({ type: 'UPDATE_PET_POINT_EVENT' });
        })
        .catch((error) => dispatch({ type: 'UPDATE_PET_POINT_EVENT_ERROR', payload: { code: 'update-pet-point-events/error', message: error } }))
    };

    const resetUpdatePetPointEventState = () => {
        dispatch({ type: 'UPDATE_PET_POINT_EVENT_RESET_STATE' });
    };

    const deletePetPointEvent = (id, countryId) => {
        dispatch({ type: 'DELETE_PET_POINT_EVENT_LOADING' });

        let db = firestoreInitialize();

        db.collection("Ciudades").doc(countryId).collection("AsignacionPuntos").doc(id).delete().then(() => {
            dispatch({ type: 'DELETE_PET_POINT_EVENT' });
        })
        .catch((error) => dispatch({ type: 'DELETE_PET_POINT_EVENT_ERROR', payload: { code: 'delete-pet-point-events/error', message: error } }))
    };

    const resetDeletePetPointEventState = () => {
        dispatch({ type: 'DELETE_PET_POINT_EVENT_RESET_STATE' });
    };

    const resetPetPointsState = () => {
        dispatch({ type: 'PET_POINTS_RESET_STATE' });
    };

    return (
        <PetPointsContext.Provider value={{
            petPointsState: state.getPetPoints,
            petPointsByIdState: state.getPetPointsById,
            petPointsEventsState: state.getPetPointsEvents,
            petPointsEventsMigrateState: state.getPetPointsEventsMigrate,
            petPointsEventsApplicationState: state.getPetPointsEventsApplication,
            migratePetPointEventsState: state.migratePetPointEvents,
            createPetPointEventsState: state.createPetPointEvents,
            deletePetPointEventState: state.deletePetPointEvent,
            updatePetPointEventState: state.updatePetPointEvents,
            getPetPoints,
            getPetPointsById,
            getPetPointsByAll,
            getPetPointsByAlly,
            getPetPointsByCustomer,
            getPetPointsByAlliesArray,
            getPetPointsByCustomersArray,
            getPetPointsEvents,
            getPetPointsEventsApplication,
            getPetPointsEventsMigrate,
            migratePetPointEvents,
            createPetPointEvents,
            updatePetPointEvent,
            deletePetPointEvent,
            resetCreatePetPointEventState,
            migratePetPointEventResetState,
            resetDeletePetPointEventState,
            resetUpdatePetPointEventState,
            resetPetPointsState,
        }}>
            {props.children}
        </PetPointsContext.Provider>
    )
}

export default PetPointsState;
